import React, { useState } from "react";
import data from "../../Json/Aboutpage/flagship.json";

const Flagship = () => {
  const [isOpen, setIsOpen] = useState(-1);

  const handleChange = (id) => {
    if (isOpen === id) {
      setIsOpen(-1);
    } else {
      setIsOpen(id);
    }
  };

  return (
    <div className=" bg-cover pt-10 w-full flagshipouter bg-no-repeat">
      <div className=" 2xl:container mx-auto lg:px-20 md:px-10 px-6 w-full flex flex-col items-center lg:flex-row w-full gap-4 md:gap-10">
        <div className="w-full lg:w-1/2 flex lg:justify-start justify-center">
          <img
            className="w-full lg:max-w-[520px]"
            src={process.env.PUBLIC_URL + data.img}
            alt="flagshipimg"
          />
        </div>
        <div className="w-full lg:w-1/2 ">
          <div className="flex flex-col justify-center mt-8">
            <div className="flex flex-col gap-3">
              <h1 className="text-24 sm:text-32 lg:text-40 font-semibold text-aboutblack">
                {data.Title}
              </h1>
              <p className="text-14 sm:text-16 lg:text-18 text-aboutpara w-full">
                {data.subheading}
              </p>
            </div>
            {/* <div className=" flex flex-col mt-12">
              {data.keypoints.map((item, id) => (
                <div
                  key={id}
                  className={`flex flex-col py-8 border-t-[1px] border-border last:border-b-[1px] last:border-border`}
                >
                  <button onClick={() => handleChange(id)}>
                    <div className="text-base lg:text-24 flex justify-between text-left">
                      <h1>{item.heading}</h1>
                      <img
                        className={`${
                          isOpen === id ? "rotate-0" : "rotate-180"
                        }`}
                        src={process.env.PUBLIC_URL + "/images/aboutus/greenarrow.svg"}
                        alt="togglearrow"
                      />
                    </div>
                  </button>
                  <div className={`${isOpen === id ? "flex" : "hidden"} py-6`}>
                    <ul className="custom-list flex flex-col gap-[18px]">
                      {item.points.map((i, index) => (
                        <li className="flex text-14 lg:text-base text-secondaryblack">
                          <span></span>
                          {i}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div> */}
            <div className="mt-10 flex flex-col gap-6 ">
              {data.points.map((item, i) => (
                <div key={i} className="flex items-center gap-3 border border-[#EFE6DC] rounded-[16px] p-2 w-full">
                  <img src={process.env.PUBLIC_URL + item.icon} alt="icon" />
                  <p className="text-18 sm:text-20  text-aboutblack">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flagship;
